/**
 * ⚡️ Gratis cadeau (cartpagina) – auto-add / auto-remove van het cadeauproduct.
 * State komt uit snippets/diek-gratis-cadeau.liquid (data-state). Na elke cart-mutatie
 * rendert het theme de sectie opnieuw, dus dit element wordt opnieuw aangemaakt en
 * beoordeelt de nieuwe state. sessionStorage voorkomt dat een handmatig verwijderd
 * cadeau direct weer terugkomt: dan tonen we een knop in plaats van auto-add.
 */
if (!customElements.get('diek-gratis-cadeau')) {
  class DiekGratisCadeau extends HTMLElement {
    static busy = false;
    static storageKey = 'diek_gift_auto';

    connectedCallback() {
      this.button = this.querySelector('[data-gift-add]');
      if (this.button) {
        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          this.addGift();
        });
      }

      // In de theme editor nooit de cart van de merchant muteren.
      if (window.Shopify && window.Shopify.designMode) return;

      switch (this.dataset.state) {
        case 'add':
          if (this.readFlag()) {
            this.dataset.state = 'manual';
          } else {
            this.addGift();
          }
          break;
        case 'remove':
          this.removeGift();
          break;
      }
    }

    readFlag() {
      try {
        return sessionStorage.getItem(DiekGratisCadeau.storageKey) === '1';
      } catch (e) {
        return false;
      }
    }

    writeFlag(value) {
      try {
        if (value) sessionStorage.setItem(DiekGratisCadeau.storageKey, '1');
        else sessionStorage.removeItem(DiekGratisCadeau.storageKey);
      } catch (e) {
        /* private mode: geen flag, dan hooguit één extra auto-add */
      }
    }

    sectionsToRender() {
      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
      );
      return sections;
    }

    async addGift() {
      if (DiekGratisCadeau.busy) return;
      DiekGratisCadeau.busy = true;
      this.classList.add('is-loading');
      try {
        const body = JSON.stringify({
          items: [{ id: Number(this.dataset.variantId), quantity: 1, properties: { _gratis_cadeau: 'ja' } }],
          sections: this.sectionsToRender(),
          sections_url: window.location.pathname,
        });
        const response = await fetch(FoxTheme.routes.cart_add_url, { ...FoxTheme.utils.fetchConfig('javascript'), body });
        const result = await response.json();
        if (!response.ok || result.status || !result.sections) {
          console.warn('[diek-gift] toevoegen mislukt', result.description || result.message || result);
          this.writeFlag(true);
          this.dataset.state = 'manual';
          return;
        }
        this.writeFlag(true);
        const cart = await (await fetch(`${FoxTheme.routes.cart_url}.js`)).json();
        cart.sections = result.sections;
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
      } catch (error) {
        console.error('[diek-gift]', error);
      } finally {
        DiekGratisCadeau.busy = false;
        this.classList.remove('is-loading');
      }
    }

    async removeGift() {
      const line = Number(this.dataset.line);
      if (!line || DiekGratisCadeau.busy) return;
      DiekGratisCadeau.busy = true;
      this.classList.add('is-loading');
      try {
        const body = JSON.stringify({ line, quantity: 0, sections: this.sectionsToRender(), sections_url: window.location.pathname });
        const response = await fetch(FoxTheme.routes.cart_change_url, { ...FoxTheme.utils.fetchConfig(), body });
        const cart = await response.json();
        // /cart/change.js meldt fouten als { status, message, description }, zonder sections.
        if (!response.ok || cart.status || cart.errors || !cart.sections) {
          console.warn('[diek-gift] verwijderen mislukt', cart.description || cart.message || cart.errors || cart);
          return;
        }
        this.writeFlag(false);
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
      } catch (error) {
        console.error('[diek-gift]', error);
      } finally {
        DiekGratisCadeau.busy = false;
        this.classList.remove('is-loading');
      }
    }
  }
  customElements.define('diek-gratis-cadeau', DiekGratisCadeau);
}
